'use client';

import Switch from '@/components/atoms/Switch';
import useProduct from '@/contexts/ProductProvider';
import { addFilterParams } from '@/services/ecommerce/utils/helper';
import cls from 'classnames';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

export const ProductSwitcher = () => {
	const { isEnglish, setIsEnglish } = useProduct();
	const router = useRouter();
	const pathname = usePathname();
	const search = useSearchParams();
	const getLang = search.get('lang');
	const handleLangChange = (l) => {
		setIsEnglish(l);
		const lang = l ? 'en' : 'bn';
		const updatedParams = addFilterParams(search, { lang: lang });
		router.push(`${pathname}?${updatedParams}`);
	};

	return (
		<div className='d-flex justify-between items-center gap-10'>
			<div className={cls(!isEnglish ? 'text-primary' : 'text-grey700')}>বাংলা</div>
			<Switch
				checked={getLang === 'bn' ? false : true}
				onChange={(e) => {
					handleLangChange(e);
				}}
			/>
			<div className={cls(isEnglish ? 'text-primary' : 'text-grey700')}>English</div>
		</div>
	);
};
